import { Button } from "@/components/ui/button";
import { useIsMobile } from "@/Hooks/useIsMobile";
import clsx from "clsx";
import { X } from "lucide-react";
import { memo } from "react";

interface PropertyWindowHeaderProps {
    title: string;
    onClose: () => void;
}

const PropertyWindowHeader = memo(({ title, onClose }: PropertyWindowHeaderProps) => {
    const isMobile = useIsMobile();

    return (
        <div className={clsx(["flex relative justify-between border-b pr-6 lg:pl-6 pl-6 mb-2",
            isMobile ? "items-start h-9" : "items-center h-[53px]",
        ])}>
            <h1 className="text-base font-semibold">{title}</h1>
            {!isMobile && (
                <Button variant="ghost" size="icon" className="w-6 h-6" onClick={onClose}>
                    <X />
                </Button>
            )}
        </div>
    );
});

PropertyWindowHeader.displayName = "PropertyWindowHeader";

export default PropertyWindowHeader;
